export default "__VITE_ASSET__14323d0c__"